import mobileGameDefaultIcon from '@/pages/opinion/assets/svg/mobile-game-default.svg';
import { useMemo } from 'react';
// rich名称转化，使用游戏id可能展示不出图片样式
export const xArr = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j'];
export default function useGameChartRich({
  xAxisList,
  gameInfoKey = 'edition_unified_id',
}: any) {
  const { xRich, gameInfo, isSingle, nameMap } = useMemo(() => {
    let gameInfo: any = {};
    let nameMap: any = {};
    let xRich = xAxisList?.reduce((pre: any, cur: any, index: number) => {
      const cover = cur?.cover ? cur?.cover : mobileGameDefaultIcon;
      gameInfo[cur[gameInfoKey]] = {
        name: cur.entity_name,
        cover: cover,
      };
      nameMap[cur[gameInfoKey]] = cur.entity_name;
      return {
        ...pre,
        [xArr[index]]: {
          backgroundColor: {
            image: cover,
          },
          align: 'center',
          width: 25,
          height: 25,
        },
      };
    }, {});

    return { xRich, gameInfo, isSingle: xAxisList.length === 1, nameMap };
  }, [xAxisList]);

  return { xRich, gameInfo, isSingle, nameMap };
}
